import { useEffect, useRef } from 'react';
import { connectAlertsWS, type WSOptions } from '@/lib/ws';

export const useAlertsWS = (opts: WSOptions, enabled = true) => {
  const wsRef = useRef<WebSocket | null>(null);
  const optsRef = useRef(opts);
  optsRef.current = opts;

  useEffect(() => {
    if (!enabled) return;

    let stopped = false;
    let retryDelay = 1000;

    const open = () => {
      const ws = connectAlertsWS({
        onMessage: (d) => optsRef.current.onMessage(d),
        onOpen: () => {
          retryDelay = 1000;
          optsRef.current.onOpen?.();
        },
        onClose: (e) => {
          optsRef.current.onClose?.(e);
          if (!stopped) {
            setTimeout(open, retryDelay);
            retryDelay = Math.min(retryDelay * 2, 30_000);
          }
        },
        onError: (e) => optsRef.current.onError?.(e),
      });
      wsRef.current = ws;
    };

    open();

    return () => {
      stopped = true;
      wsRef.current?.close();
    };
  }, [enabled]);

  return wsRef;
};
